export function doSearch() {

    jQuery(document).ready(function() {

        wp.hooks.addAction('jb_jobs_list_do_search', 'testtest', function(jobs_list){
            console.log('in addAction');
            
            var salary =  jQuery('.jb-salary').val();
            // console.log(salary);
            wp.JB.jobs_list.url.set(jobs_list, 'jb-salary', salary);
        });

        wp.hooks.addFilter('jb_jobs_request', 'stca-salary-ajax', function(request, jobs_list){
            request.salary = jQuery('.jb-salary').val();
            return request;
        })
        
    });
}
